/**
 * extract in an array all url contain in a text
 * @param fullText : string with or without url inside
 */
export const extractUrls = function (fullText: string): string[] {
    return fullText ? fullText.match(/\bhttps?:\/\/\S+/gi) : null;
};